import { debounce } from 'lodash';
import { ChangeEventHandler, useCallback, forwardRef } from 'react';
import { RegisterOptions  } from 'react-hook-form';
import useStyles from './styles';

interface ILabelTextAreaProps {
  label?: string;
  value?: string;
  placeholder?: string;
  optional?: boolean;
  customClass?: string;
  onChange?: ChangeEventHandler | undefined;
  name?: string;
  onBlur?: any;
  required?: boolean | string;
  errors?: any;
  showErrors?: boolean;
  disable?: boolean;
  maxLength?: number;
  register?: ((val: string, val2: RegisterOptions) => {}) | ((val2: RegisterOptions) => {})
  cypressId?: string;
}

const LabelTextArea = forwardRef((props: ILabelTextAreaProps, ref: any) => {
  const styles = useStyles();
  const {
    label,
    value,
    placeholder,
    onChange,
    optional,
    customClass,
    onBlur,
    name,
    required,
    errors,
    disable,
    maxLength,
    register,
    showErrors,
    cypressId
  } = props;


  // @ts-ignore
  const onBlurDelay = useCallback(debounce(
      () => {
        if (onBlur) {
          onBlur();
        }
      },
      1000,
      {
        leading: true,
        trailing: false,
      }
    )
  ,
    [onBlur]
  );

  return (
    <div
      className={`${styles.container} ${customClass} ${
        !!errors && styles.containerErr
      } ${disable && styles.disable}`}
    >
      {
        label &&    
          <label className={styles.textLabel}>
            {label}
            {optional && <span className={styles.textOptional}> · Optional</span>}
          </label>
      }

      <textarea
        name={name}
        ref={ref}
        className={styles.textArea}
        placeholder={placeholder || ''}
        value={value}
        {...register?.(name ? name : "", { required })}
        onChange={onChange}
        onBlur={onBlurDelay}
        required={!!required}
        disabled={disable}
        maxLength={maxLength}
        data-cy={cypressId}
      />
      {showErrors && errors && name && <p className={styles.errors}>{errors?.[name]?.message}</p>}
    </div>
  );
});

export default LabelTextArea;
